<template>
  <section
    class="component-a590b44b"
    resmed-component-name="product_video_carousel_text_cta"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
    v-bind:class="[`line-${acf.layout['line-position']}`]"
    v-bind:id="[`${acf.layout['id']}`]"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h2 class="heading-lg" v-if="acf.headline" v-html="acf.headline"></h2>
              <div
                v-if="acf.description"
                class="mb-4"
                v-html="acf.description"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div style="overflow: hidden">
        <div class="swiper container">
          <div class="row">
            <div
              class="col col-md-10 offset-md-1 col-lg-12 offset-lg-0"
              style="padding: 0"
            >
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    ($root.mode === 'md' && acf.items.length > 2) ||
                    (['lg', 'xl'].includes($root.mode) && acf.items.length > 4)
                  "
                >
                  <a
                    href="javascript:void(0)"
                    ref="swiperButtonPrev"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    href="javascript:void(0)"
                    ref="swiperButtonNext"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="swiper-container"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    v-bind:class="{
                      '-justify-content-center': acf.items.length < 4,
                      'center-mode': acf.items.length < 2,
                    }"
                  >
              
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(item, index) in items"
                      v-bind:key="item.id || index"
                      v-bind:modal-video-id="item.id"
                      v-on:click.prevent="modal(item.player, item.id, getVideoUrl(item), item.aprimo_subtitle)"
                      v-bind:class="{ 'is-active': active === item.id }"
                    >

                  
                      <div class="embed-responsive embed-responsive-16by9">
                        <figure class="embed-responsive-item">
                          <figcaption>
                            <p class="now-playing">Now playing </p>
                          </figcaption>
                          <div
                            class="embed-responsive-item poster"
                            v-bind:style="{
                              'background-image': `url(${item.aprimo_thumbnail})`,
                            }"
                          ></div>
                        </figure>
                      </div>
                      <p class="mt-3">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && acf.items.length > 1) ||
              ($root.mode === 'md' && acf.items.length > 2) ||
              (['lg', 'xl'].includes($root.mode) && acf.items.length > 4)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import scrollTarget from "../../mixins/scroll-target";

export default {
  name: "component-a590b44b", // product_video_carousel_text_cta
  props: ["acf"],
  data() {
    return {
      slider: undefined,
      active: "", // id
      items: [],
    };
  },
  mixins: [helper, scrollTarget],
  methods: {
    getVideoUrl(item) {
      return item.aprimo_url || item.hls_url || "";
    },
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
        aprimo_url: arg[2] || null,
        aprimo_subtitle: arg[3] || null,
      });

      this.active = arg[1];
    },
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
  created() {
    this.items = (this.acf.items || []).map((item) => ({
      ...item,
      poster:
        item.thumbnail ||
        item.aprimo_thumbnail ||
        item.poster_url ||
        item.poster ||
        "",
    }));

    bus.$on("overlay:active:boolean", (val) => {
      if (!val) {
        this.active = "";
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a590b44b {
  position: relative;
  padding: 5rem 0 4rem 0;

  &:before {
    content: "";
    width: 70vw;
    height: 1px;
    background-color: rgba($cc-resmed-white, 0.25);
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &.line-top {
    &:before {
      bottom: auto;
      top: 0;
    }
  }
}

.component {
  &.text-color-white {
    h2,
    ~ * {
      color: $cc-resmed-white;
    }

    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    position: relative;
    margin-bottom: 0.75rem;

    @extend %eyebrow-center;
    &:before {
      background-color: $cc-resmed-black;
    }
  }

  .swiper {
    padding: 0 3.5rem;

    @media (min-width: 768px) {
      padding: 0;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 768px) and (max-width: 991px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-3rem) scale(1.175);

      @media (min-width: 992px) {
        transform: translateX(-4rem) scale(1.4);
      }
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(3rem) scale(1.175);

      @media (min-width: 992px) {
        transform: translateX(4rem) scale(1.4);
      }
    }
  }

  .-mode-xs,
  .-mode-sm {
    &.swiper-container {
      overflow: visible;
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      overflow: hidden;
    }
  }

  .swiper-container {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;

    margin: 0 auto;
    padding: 1rem 0 0.5rem 0;

    @media (min-width: 768px) {
      padding: 1rem 0 2rem 0;
    }
  }

  .items {
    display: flex;
    align-items: stretch;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;

    &.-justify-content-center {
      @media (min-width: 992px) {
        justify-content: center;
      }
    }
    &.center-mode {
      @media (max-width: 768px) {
        justify-content: center;
      }
    }
  }

  .item {
    // display: flex;
    flex-shrink: 0;
    align-items: center;
    padding: 0 0.725rem;

    > div {
      box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    }

    .poster {
      background-size: cover;
    }

    .embed-responsive-item {
      border-radius: 6px;
      overflow: hidden;
    }

    figure {
      cursor: pointer;

      > div:first-child {
        width: 100%;
        background-color: $cc-resmed-white;
        position: absolute;
        z-index: 2;
      }

      &:before {
        content: "";
        position: absolute;
        width: 100%;
        padding-top: 56.25%;
        z-index: 3;
        background-image: url("#{$assets}/images/icon-play-button.svg");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 4rem 4rem;
        opacity: 0.925;
        transition: opacity 0.5s ease;
      }

      &:hover {
        &:before {
          opacity: 1;
        }
      }

      figcaption {
        padding: 1.25rem 1.5rem;
        color: $cc-resmed-white;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
    }

    &.is-active {
      .now-playing {
        display: block;
      }

      figure {
        &:before {
          display: none;
        }
      }
    }

    .now-playing {
      @extend %body-small-bold;
      background: $cc-resmed-grey-70;
      opacity: 0.925;

      display: inline-block;
      padding: 0.675rem 2rem;
      border-radius: 1.5rem;

      white-space: nowrap;
      display: none;
    }
  }
}
</style>
